<template>
  <div v-if="props.open">
    <div class="fixed inset-0 z-40 hidden bg-black opacity-50 sm:block" />
    <div
      class="fixed inset-0 z-50 py-6 overflow-auto bg-white sm:bg-transparent sm:p-12"
      @click.self="$emit('close')"
    >
      <div class="max-w-4xl mx-auto bg-white sm:pb-20 sm:shadow z-20 relative">
        <div
          class="text-indigo-base py-4 pr-4 pl-24 flex items-stretch"
          :class="`${secondaryColor}` ? 'bg-gray-275' : 'bg-teal-accent'"
        >
          <p class="flex-1 uppercase font-bold text-sm">
            {{ props.title }}
          </p>
          <button
            :class="`block h-6 w-6 flex items-center justify-center ${secondaryColorClass}`"
            @click="$emit('close')"
          >
            <span class="sr-only">Close</span>
            <svg
              focusable="false"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-x"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        <div class="px-24 py-5">
          <p class="text-sm text-indigo-base font-medium mt-4">
            {{ props.description }}
          </p>

          <ul class="list-disc ml-5">
            <li
              v-for="item in props.items"
              :key="item"
              class="text-sm font-medium"
            >
              {{ item }}
            </li>
          </ul>
          <slot name="modal-content" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps } from "vue";

defineEmits(["close"]);

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "",
  },
  items: {
    type: Array,
    default: () => [],
  },
  description: {
    type: String,
    default: "",
  },
});
</script>
